import * as React from "react";
import { ITypedOption } from "../../../models/common/typedOption";
import { RecordPageList } from "./RecordPageList/RecordPageList";
import { IRecordPage } from "../../../models/record/recordPage";
import { RecordPageEdit } from "./RecordPageEdit";
import { IAppSessionState } from "../../../models/store/storeTypes";
import { recordLockManager } from "../../../models/services/recordLockService";
import { abortManager } from "source/models/services/tokenService";
import { RouteComponentProps } from "react-router-dom";
import { IRecordListState, IRecordReportState } from "source/models/store/record";

// RecordPage
export interface IRecordPageOwnProps {
}

export interface IRecordPageStateProps {
    appState: IAppSessionState;
    dataId: number;
    recordPage: IRecordPage;
    list: IRecordListState;
    report: IRecordReportState;
}

export interface IRecordPageDispatchProps {
    onGetRecordsPage: () => void;
    onLogout: () => void;
    onSetCulture: (culture: string) => void;
    onSaveUserParameters: (parameters: ITypedOption[]) => void;
    onRefreshSessionState: () => void;
}

export interface IRecordPagePathProps {
    page: string;
}

type RecordPageProp = IRecordPageOwnProps & IRecordPageStateProps & IRecordPageDispatchProps & RouteComponentProps<IRecordPagePathProps>;

export class RecordPage extends React.Component<RecordPageProp, {}> {
    constructor(props: RecordPageProp) {
        super(props);
        abortManager.abortAll(); //Abort all abortable calls regardless of module
    }
    
    componentDidMount(): void {
        const sessionState = this.props.appState.state;
        recordLockManager.unlockAll(sessionState?.companyId, sessionState?.code);
    }
    
    render() {
        const props = this.props;
        if (props.appState.state.canUseRecords) {
            return (
                <RecordPageList
                    appState={props.appState}
                    list={props.list}
                    report={props.report}
                    dataId={props.dataId}
                    page={props.match.params.page}
                    pageList={props.recordPage?.list}
                    onGetRecordsPage={props.onGetRecordsPage}
                    onLogout={props.onLogout}
                    onSetCulture={props.onSetCulture}
                    onSaveUserParameters={props.onSaveUserParameters}
                    onRefreshSessionState={props.onRefreshSessionState}
                />
            );
        } else {
            return (
                <RecordPageEdit
                    appState={props.appState}
                    dataId={props.dataId}
                    pageEdit={props.recordPage?.edit}
                    onGetRecordsPage={props.onGetRecordsPage}
                    onLogout={props.onLogout}
                    onSetCulture={props.onSetCulture}
                    onSaveUserParameters={props.onSaveUserParameters}
                    onRefreshSessionState={props.onRefreshSessionState}
                />
            );
        }
    }
}